import { ACTIVATION_STEPS_KEY } from 'constants/signup';
import { isSllrUser } from './helpers';

export const getSignUpPath = () => `/signup`;

export const getActivationStepIndex = (stepKey) => {
  const {
    VERIFY_EMAIL,
    SHIPPING_PRICES,
    BUSINESS_PROFILE,
    PICKUP_LOCATION,
    BANK_ACCOUNT,
    ACCOUNT_TYPE,
    SUMMARY
  } = ACTIVATION_STEPS_KEY;

  const orderedSteps = [
    VERIFY_EMAIL,
    ...(isSllrUser() ? [SHIPPING_PRICES] : []),
    BUSINESS_PROFILE,
    PICKUP_LOCATION,
    BANK_ACCOUNT,
    ACCOUNT_TYPE,
    SUMMARY
  ];

  return orderedSteps.findIndex((value) => value === stepKey);
};
